import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import Transaction, { Load_Transaction } from "../Transaction/Transaction";
import { Pre_Loading, Show_Message } from "../General/Messagedialogbox";
import { API_POST } from "../General/Utility";
import { Clear_Transaction } from "../features/Transactionstates";

function SalesEnquiry() {
  const dispatch = useDispatch();
  const _AuthParems = useSelector((state) => state.Common.Admin);
  const _Common = useSelector((store) => store.Transstates.Common);
  const _HT = useSelector((store) => store.Transstates.Header);
  const _DT = useSelector((store) => store.Transstates.Data);
  const _Sum = useSelector((store) => store.Transstates.Summary);
  const _Disc = useSelector((store) => store.Transstates.Discount);

  const _iScrId = 13;

  useEffect(() => {
    Load_Transaction(dispatch, _Common, _iScrId);
  }, []);

  const SaveClick = async () => {
    try {
      console.log("SAVE CLICK TRIGGERED");

      // 0️⃣ Guard: Ensure Header state is fully loaded before proceeding.
      // _HT can be undefined when loading an existing invoice if the async
      // Load_Transaction hasn't finished populating the Redux store yet.
      if (!_HT) {
        Show_Message(
          dispatch,
          "Transaction header not loaded. Please wait and try again.",
          "error"
        );
        return;
      }

      // 1️⃣ Validate Product Rows
      if (!Array.isArray(_DT?.arrEntDT) || _DT.arrEntDT.length === 0) {
        Show_Message(dispatch, "Atleast One Product Required", "error");
        return;
      }

      // 2️⃣ Validate Voucher Numbering from Header
      if (
        !_HT.iNumSeqNo ||
        !_HT.strPrefix ||
        !_HT.strCompCode ||
        !_HT.strFinanFrom ||
        !_HT.strTransNo
      ) {
        Show_Message(
          dispatch,
          "Voucher number format not loaded. Please refresh.",
          "error"
        );
        return;
      }

      Pre_Loading(dispatch, true);

      const safeDecimal = (val) => {
        const num = Number(val);
        return isNaN(num) ? 0 : num;
      };

      const SalEnqListHT = {
        iBranchId: Number(_AuthParems.Branch),
        iSalEnqId: _HT.iVouchId,
        iTitleTag: _Common.iScrId,
        iPartyId: _HT.iPartyId,
        strShippingAdd:
          _HT.strShippingAdd === "" ? _HT.strPartyAdd : _HT.strShippingAdd,

        iNumSeqNo: _HT.iNumSeqNo,
        strPrefix: _HT.strPrefix,
        strCompCode: _HT.strCompCode,
        strFinanFrom: _HT.strFinanFrom,
        strTransNo: _HT.strTransNo,

        strVouchNo: _HT.strVouchNo,
        strVouchDate: _HT.strVouchDate,

        iAddLessBillDiscId: _HT.iALBillDiscId,
        iBillTypeId: _HT.iBillTypeId,
        iTaxCalcOnId: _HT.iTaxCalcOnId,
        iTaxTypeId: _HT.iTaxRelId,
        iDMId: _HT.iDMId,

        strConvertDCVouch: _HT.strConvertDCVouch,
        strPartyDCVouch: _HT.strPartyDCVouch,

        strRefNum1: _HT.strRefNum1,
        dpRefNum1Date: _HT.dpRefNum1Date,
        strRefNum2: _HT.strRefNum2,
        dpRefNum2Date: _HT.dpRefNum2Date,
        strRefNum3: _HT.strRefNum3,
        dpRefNum3Date: _HT.dpRefNum3Date,
        strRefNum4: _HT.strRefNum4,
        dpRefNum4Date: _HT.dpRefNum4Date,

        strRemark1: _HT.strRemark1,
        strRemark2: _HT.strRemark2,
        strRemark3: _HT.strRemark3,
        strRemark4: _HT.strRemark4,

        strValidity: _HT.strValidity,
        dpValDateUpto: _HT.dpValDateUpto,
        strPayTerm: _HT.strPayTerm,
        dpPayTermDateUpto: _HT.dpPayTermDateUpto,
        strDeliTerm: _HT.strDeliTerm,
        dpDelTermDateUpto: _HT.dpDelTermDateUpto,

        strEComGstNo: _HT.strEComGstNo,
        strTransport: _HT.strTransport,
        strVehicle: _HT.strVehicle,
        strDespatch: _HT.strDespatch,
        dpDespatchDate: _HT.dpDespatchDate,
        strLRNNumber: _HT.strLRNNumber,
        dpLRNoDate: _HT.dpLRNoDate,
        strAgent: _HT.strAgent,
        strReference: _HT.strReference,
        strDestination: _HT.strDestination,

        dTBillDiscPer: safeDecimal(_Disc?.dBillDisPer),
        dTBillDiscAmt: safeDecimal(_Disc?.dBillDisAmt),
        dTBillDiscValue: safeDecimal(_Disc?.dBillDisValue),

        dTAddLessDiscPer: safeDecimal(_Disc?.dALBillDisPer),
        dTAddLessDiscAmt: safeDecimal(_Disc?.dALBillDisAmt),
        dTAddLessDiscValue: safeDecimal(_Disc?.dALBillDisValue),

        dTotQty: safeDecimal(_Sum?.Qty),
        dTotGoodval: safeDecimal(_Sum?.GoodsValue),
        dTotDiscount: safeDecimal(_Sum?.TotalDiscount),
        dTotTax: safeDecimal(_Sum?.TotalTax),
        dAddLess: safeDecimal(_Sum?.TotalAddLess),
        dTotTCSTax: safeDecimal(_Sum?.TotalTCSTax),
        dRoundOff: safeDecimal(_Sum?.RoundOff),
        dNetAmt: safeDecimal(_Sum?.NetAmt),
      };

      console.log("Calling API: SalesEnquiry/InsUpd_SalesEnquiry");
      console.log(SalEnqListHT, {
        objEntSI: SalEnqListHT,
        objBaseTransDT: _DT.arrEntDT,
        objEntALDT: _DT.arrEntAL,
        objEntTax: _DT.arrEntTax,
        iUserId: Number(_AuthParems.User),
        FYid: Number(_AuthParems.Year),
        strDBName: _AuthParems.DB,
        objDTHelp: _DT.arrEntDTHelp,
      });

      const res = await API_POST(
        "SalesEnquiry/InsUpd_SalesEnquiry",
        {
          objEntSI: SalEnqListHT,
          objBaseTransDT: _DT.arrEntDT,
          objEntALDT: _DT.arrEntAL,
          objEntTax: _DT.arrEntTax,
          iUserId: Number(_AuthParems.User),
          FYid: Number(_AuthParems.Year),
          strDBName: _AuthParems.DB,
          objDTHelp: _DT.arrEntDTHelp,
        },
        dispatch
      );

      if (res?.strStatus === "Success") {
        Show_Message(dispatch, res.strMessage, "success");
        Clear_Click();
      } else {
        Show_Message(dispatch, res?.strMessage || "Save Failed", "error");
      }
    } catch (error) {
      console.error("Save Error:", error);
      Show_Message(dispatch, error.message, "error");
    } finally {
      Pre_Loading(dispatch, false);
    }
  };

  const Clear_Click = async () => {
    try {
      await Pre_Loading(dispatch, true);
      await dispatch(Clear_Transaction());
      await Load_Transaction(dispatch, _Common, _Common.iScrId);
    } catch (e) {
      await Show_Message(dispatch, e.message, "error");
    } finally {
      await Pre_Loading(dispatch, false);
    }
  };

  return <Transaction Save={SaveClick} ScrId={_iScrId} />;
}

export default SalesEnquiry;